import { Question } from "./QuestionTypes"
import { parse, differenceInCalendarYears } from "date-fns"

// check for non-alphabetical choices
// x.filter(
// 	i =>
// 		i.choices &&
// 		i.choices.map(i => i.option).join(",") !==
// 			i.choices
// 				.map(i => i.option)
// 				.sort()
// 				.join(",")
// )
// const year = new Date().getFullYear()

// console.log(JSON.stringify(sa.map(i => ({category: i.Category, challenge: i.Challenge, answer: i.Answer}))))
// console.log(JSON.stringify(mc.map(i => ({category: i.Category, challenge: i.Challenge, options: [{data: i.C1, correct: true}, {data: i.C2}, {data: i.C3}, {data: i.C4}].sort((a, b) => a.data.localeCompare(b.data))}))))

// const ageNum = (years: number, months: number, days: number) =>
// 	differenceInCalendarYears(new Date(years, months, days), now)

const now = new Date()
const age = (ymd: string) => differenceInCalendarYears(now, parse(ymd, "yyyy-MM-dd", now))

export const questions: Question[][] = [
	[
		// {
		// 	category: "music",
		// 	challenge: "Which Beetle was born first?",
		// 	choices: [
		// 		{ option: "George Harrison", data: age("1942-06-18") },
		// 		{ option: "John Lennon", data: age("1940-10-09") },
		// 		{ option: "Paul McCartney", data: age("1943-02-25") },
		// 		{ option: "Ringo Starr", data: age("1940-07-07"), correct: true },
		// 	],
		// 	reveal: "ringo-starr.png",
		// },
		{
			category: "games",
			challenge: "Which would you NOT find in a Powerlifting competition?",
			choices: [
				{ option: "Bench press" },
				{ option: "Deadlift" },
				{ option: "Power clean", correct: true },
				{ option: "Squat" },
			],
			reveal: "powerclean.jpg",
		},
		// {
		// 	challenge: "Which is not the name of a search engine?",
		// 	choices: [
		// 		{ option: "Excite" },
		// 		{ option: "AltaVista" },
		// 		{ option: "Lycos" },
		// 		{ option: "Ping", correct: true },
		// 	],
		// 	category: "tech",
		// 	reveal: "bing.svg",
		// },
		{
			category: "tech",
			challenge: "Which programming language is embedded in modern web browsers?",
			choices: [
				{ option: "C++" },
				{ option: "Java" },
				{ option: "JavaScript", correct: true },
				{ option: "Python" },
			],
			reveal: "javascript.png",
		},
		{
			category: "film",
			challenge: "When did Sesame Street premiere?",
			choices: [{ option: "1949" }, { option: "1959" }, { option: "1969", correct: true }, { option: "1979" }],
			content: "sesamestreet.webp",
		},
		{
			category: "national",
			challenge: "Who is the oldest living Prime Minister of Canada?",
			choices: [
				{ option: "Brian Mulroney", data: age("1939-03-20") },
				{ option: "Jean Chrétien", data: age("1934-01-11"), correct: true },
				{ option: "Joe Clark", data: age("1939-06-05") },
				{ option: "Paul Martin", data: age("1938-08-28") },
			],
			reveal: "jeanchretien.jfif",
		},
		// {
		// 	category: "local",
		// 	challenge: "By road, where is the nearest Ikea?",
		// 	choices: [
		// 		{ option: "Coquitlam 1327" },
		// 		{ option: "Edmonton 1323" },
		// 		{ option: "Kelowna", correct: true },
		// 		{ option: "Richmond 1354" },
		// 	],
		// },
		{
			category: "local",
			challenge: "In a straight line, which city is closest?",
			choices: [
				{ option: "Golden", data: 857 },
				{ option: "Grand Prairie", data: 628, correct: true },
				{ option: "Kelowna", data: 804 },
				{ option: "Vancouver", data: 691 },
			],
			reveal: "near-terrace.png",
			suffix: "km",
		},
		{
			category: "life",
			challenge: "Which animal is not real?",
			choices: [
				{ option: "Chicken turtle" },
				{ option: "Elephant hawk moth" },
				{ option: "Hellbender" },
				{ option: "Spiked devil bird", correct: true },
			],
			reveal: "real-animals.jpg",
		},
		{
			category: "industry",
			challenge: "Which tech giant is not headquartered in California?",
			choices: [
				{ option: "Apple" },
				{ option: "Facebook" },
				{ option: "Google" },
				{ option: "Microsoft", correct: true },
			],
			reveal: "microsoft-hq.png",
		},
		{
			category: "health",
			challenge: "Ibuprofen is the active ingredient in…",
			choices: [
				{ option: "Advil", correct: true },
				{ option: "Aleve" },
				{ option: "Aspirin" },
				{ option: "Tylenol" },
			],
			reveal: "advil.jpg",
		},
		{
			category: "industry",
			challenge: "On a 10-24 screw, the 24 indicates the screw's…",
			choices: [
				{ option: "Brittleness" },
				{ option: "Length" },
				{ option: "Oxidation resistance" },
				{ option: "Thread density", correct: true },
			],
			reveal: "screw.png",
		},
		{
			category: "world",
			challenge: "What is Joe Biden's middle name?",
			choices: [
				{ option: "Antoinette" },
				{ option: "Janette" },
				{ option: "Marionette" },
				{ option: "Robinette", correct: true },
			],
			content: "joebiden.jpg",
			citation: "https://en.wikipedia.org/wiki/Joe_Biden",
		},
		{
			category: "tech",
			challenge: "What is the F-35 code name?",
			choices: [
				{ option: "Eagle" },
				{ option: "Felon" },
				{ option: "Hornet" },
				{ option: "Lightning", correct: true },
			],
			content: "f35.jpg",
			reveal: "f35-logo.webp",
			citation: "https://en.wikipedia.org/wiki/Lockheed_Martin_F-35_Lightning_II",
		},
		{
			category: "tech",
			challenge: "How many keys are on a standard computer keyboard? (US English, ISO/IEC 9995-1)",
			choices: [{ option: "56" }, { option: "64" }, { option: "88" }, { option: "104", correct: true }],
			reveal: "keyboard.svg",
			citation: "https://en.wikipedia.org/wiki/Keyboard_layout",
		},
		{
			category: "health",
			challenge: "Which is NOT a vital sign?",
			choices: [
				{ option: "Blood pressure" },
				{ option: "Heart rate" },
				{ option: "RBC count", correct: true },
				{ option: "Temperature" },
			],
			reveal: "vital-signs.png",
		},
		{
			category: "local",
			challenge: "Which is NOT the name of a nearby Provincial Park",
			choices: [
				{ option: "Hai Lake" },
				{ option: "Kleanza" },
				{ option: "Remo", correct: true },
				{ option: "Sleeping Beauty" },
			],
			reveal: "parks.png",
		},
		{
			category: "literature",
			challenge: "What does MLA stand for in the MLA Style Manual for academic publishing?",
			choices: [
				{ option: "Massechusetts Liguistics Academy" },
				{ option: "Metropolitan Literature Alliance" },
				{ option: "Modern Language Association", correct: true },
				{ option: "Morphological Lexicons of America" },
			],
			reveal: "mla.png",
		},
		{
			category: "industry",
			challenge: "How many millilitres are in one fluid ounce?",
			choices: [{ option: "5" }, { option: "18" }, { option: "30", correct: true }, { option: "80" }],
			citation: "https://www.inchcalculator.com/convert/milliliter-to-fluid-ounce/",
		},
		{
			category: "literature",
			challenge: "The Divine Comedy includes the story called",
			choices: [
				{ option: "Dante's Inferno", correct: true },
				{ option: "The Odyssey" },
				{ option: "Paradise Lost" },
				{ option: "The Tempest" },
			],
			reveal: "divine-comedy.png",
		},
		{
			category: "life",
			challenge: "Which is NOT a dinosaur",
			choices: [
				{ option: "Argentinosaurus" },
				{ option: "Doomasaurus", correct: true },
				{ option: "Dreadnoughtus" },
				{ option: "Pteranodon" },
			],
		},
		{
			category: "industry",
			challenge: "Which is the largest Ford SUV?",
			choices: [
				{ option: "Edge" },
				{ option: "Escape" },
				{ option: "Expedition", correct: true },
				{ option: "Explorer" },
			],
			reveal: "expedition.jpg",
		},
		// {
		// 	category: "tech",
		// 	challenge: "Who is older?",
		// 	choices: [
		// 		{ option: "Jeff Bezos", data: 58 },
		// 		// { option: "Steve Balmer", data: 66 },
		// 		{ option: "Mark Zuckerberg", correct: true, data: 38 },
		// 		{ option: "Elon Musk", data: 51 },
		// 		// { option: "Eric Schmidt", data: 67 },
		// 		{ option: "Steve Jobs", data: 67 },
		// 		// { option: "Bill Gates", data: 67 },
		// 	],
		// 	reveal: "zuckerberg.jpg",
		// },
		{
			challenge: "What colour is represented by hex code #FFFF00?",
			reveal: "ffff00.svg",
			choices: [{ option: "Green" }, { option: "Pink" }, { option: "Purple" }, { option: "Yellow", correct: true }],
			category: "tech",
		},
	],
	[
		{
			category: "tech",
			challenge: "Who is this?",
			content: "developers.mp4",
			fullscreen: true,
			answer: "Steve Balmer",
			reveal: "steve-ballmer.webp",
		},
		// { category: "world", challenge: "Who is this?", answer: "Stephen Fry", content: "stephen-fry.jpg" },
		{
			category: "music",
			challenge: "What is Ringo Starr's real name?",
			answer: "Richard Starkey",
			content: "ringo-starr.png",
		},
		{
			category: "tech",
			challenge: "What was Microsoft's iPod competitor called?",
			answer: "Zune",
			reveal: "zune.jpg",
		},
		{
			category: "world",
			challenge: "Which recently deceased Soviet politician oversaw the fall of the USSR?",
			answer: "Michael Gorbachev",
			content: "gorbachev.webp",
		},
		{
			category: "industry",
			challenge: "Which retail company saw its stock jump in price over 18x in three weeks in early 2021?",
			answer: "GameStop ($GME)",
			reveal: "gamestop.svg",
		},
		{
			category: "tech",
			challenge: 'At a Windows desktop, what does pushing the "Windows" key do?',
			answer: "Toggle the Start Menu",
			reveal: "start.png",
		},
		{
			category: "local",
			challenge: "What object is the door handles at the new Tim Hortons made to resemble?",
			answer: "Hockey stick",
			reveal: "timhortons.jpg",
		},
		{
			category: "world",
			challenge: "What was the name of Japan's recently assassinated former Prime Minister?",
			answer: "Shinzo Abe (安倍 晋三)",
			reveal: "shinzo-abe.jpg",
		},
		{
			category: "national",
			challenge: "What day is Truth and Reconcilation Day?",
			answer: "September 30th",
			content: "reconciliation.jpg",
			reveal: "reconciliation-reveal.jpg",
		},
		{
			category: "industry",
			challenge: "What is the minimum NEC-permitted wire guage for a standard 15A household circuit?",
			answer: "14 gauge",
			reveal: "wire.png",
		},
		// { category: "world", challenge: "Who is this man?", answer: "Warren Buffett", content: "buffett.jpg" },
		{
			category: "games",
			challenge: "Who won the 2021 Stanley Cup?",
			answer: "Tampa Bay Lightning",
			reveal: "tampa.svg",
		},
		{ category: "tech", challenge: 'What company makes "Photoshop"?', answer: "Adobe Inc.", reveal: "adobe.svg" },
		{
			category: "health",
			challenge: "In the medical field, what does ECG stand for?",
			answer: "Electrocardiogram",
			reveal: "ecg.jpg",
		},
		{
			category: "local",
			challenge: "What is Terrace's latitude/longitude (rounded up or down to the nearest integer on either axis)",
			answer: "Lat: 54.5 / Lng: -128.6",
		},
		{
			category: "world",
			challenge: "Name a country on Mexico's southern border",
			answer: "Guatemala or Belize",
			reveal: "south-mexico.png",
		},
		// {
		// 	challenge: "What major Indian river runs through New Delhi?",
		// 	category: "world",
		// 	answer: "Ganges",
		// 	reveal: "ganges-map.jpg",
		// 	content: "delhi-ganges.jpg",
		// },
		// {
		// 	category: "philosophy",
		// 	challenge: "What is the answer to the below matrix multiplication?",
		// 	answer: "64",
		// 	content: "matrix-question.svg",
		// 	reveal: "matrix-answer.svg",
		// 	notransition: true,
		// },
		// { category: "world", challenge: "How many coalition wars were faught against Napoleon Bonaparte?", answer: "7" },
		{
			challenge: "In which city was Jack the Ripper based?",
			answer: "London",
			content: "jacktheripper.jpg",
			reveal: "london.jpg",
			category: "world",
		},
		// {
		// 	category: "tech",
		// 	challenge: "Which company manufactures photocopiers?",
		// 	choices: [
		// 		{ option: "Nikon" },
		// 		{ option: "Konica Minolta", correct: true },
		// 		{ option: "Yamaha" },
		// 		{ option: "IBM" },
		// 	],
		// 	reveal: "konica-minolta.svg",
		// 	content: "photocopier.jpg",
		// },
		{
			category: "tech",
			challenge: "The soon-to-be-replaced current generation is the iPhone #...",
			answer: "13",
			content: "iphone13.jpg",
		},
		{ category: "science", challenge: "What is the SI unit for torque?", answer: "Nm", content: "torque.gif" },
		{
			category: "national",
			challenge: "In what year was the last Canadian federal election?",
			content: "trudeau.jpg",
			answer: "September 20, 2021",
			citation: "https://en.wikipedia.org/wiki/2021_Canadian_federal_election",
		},
		{
			category: "world",
			challenge: "What is the official language of Mali",
			answer: "French",
			citation: "https://en.wikipedia.org/wiki/Mali",
			content: "mali.svg",
		},
		// {
		// 	challenge: "Who succeeded Mary Queen of Scots?",
		// 	category: "world",
		// 	answer: "James VI (James Charles Stuart)",
		// 	content: "james-vi.jpg",
		// },
	],
	[
		{
			category: "film",
			challenge: "What show is this?",
			answer: "She-Hulk",
			content: "shehulk.mp4",
			fullscreen: true,
			reveal: "shehulk.jpg",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "One Hour Photo",
			content: "onehourphoto.mp4",
			reveal: "onehourphoto.jpg",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Who is the artist?",
			answer: "The Outfield",
			content: "yourlove.mp4",
			fullscreen: true,
			reveal: "theoutfield.jpg",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "Heat",
			content: "heat.mp4",
			fullscreen: true,
			reveal: "heat.webp",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "Flight",
			content: "flight.mp4",
			reveal: "flight.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "Groundhog Day",
			content: "groundhogday.mp4",
			fullscreen: true,
			reveal: "groundhogday.jpg",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "american-psycho.mp4",
			reveal: "american-psycho.png",
			answer: "American Psycho (2000)",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "What show is this?",
			answer: "Peaky Blinders",
			content: "peakyblinders.mp4",
			fullscreen: true,
			reveal: "peakyblinders.jpg",
		},
		{
			category: "music",
			challenge: "What song is this?",
			answer: "Unbreak My Heart - Toni Braxton",
			content: "unbreak.mp4",
			fullscreen: true,
			reveal: "unbreak-reveal.mp4",
		},
		{
			category: "music",
			challenge: "What song is this?",
			answer: "Jump - Van Halen",
			content: "jump.mp4",
			fullscreen: true,
			reveal: "jump-reveal.mp4",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "The Thin Red Line",
			content: "thinredline.mp4",
			fullscreen: true,
			reveal: "thinredline.jpg",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "The Machinist",
			content: "machinist.mp4",
			fullscreen: true,
			reveal: "machinist.jpg",
		},
		{
			category: "music",
			challenge: "Who is the artist?",
			answer: "Richard Marx",
			content: "righthere.mp4",
			fullscreen: true,
			reveal: "richard-marx.jpg",
		},
		{
			category: "film",
			challenge: "Name the actor",
			answer: "Robert Pattinson",
			content: "batman.mp4",
			fullscreen: true,
			reveal: "pattinson.jpg",
		},
		{
			challenge: "What song is this?",
			answer: "Heat Waves - Glass Animals",
			category: "music",
			content: "heatwaves.mp4",
			fullscreen: true,
			reveal: "heatwaves-reveal.mp4",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "Boogie Nights",
			content: "boogienights.mp4",
			fullscreen: true,
			reveal: "boogienights.jpg",
		},
		{
			category: "music",
			challenge: "What song is this?",
			answer: "Total Eclipse of the Heart - Bonnie Tyler",
			content: "totaleclipse.mp4",
			fullscreen: true,
			reveal: "totaleclipse-reveal.mp4",
		},
		{
			challenge: "Name the artist",
			category: "music",
			answer: "Harry Styles (performing As it Was)",
			content: "asitwas.mp4",
			fullscreen: true,
			reveal: "harrystyles.jpg",
		},
		{
			challenge: "Who is this rapper?",
			category: "music",
			answer: "Lil Dicky",
			content: "lildicky.mp4",
			reveal: "lildicky.jpg",
		},
		{
			category: "film",
			challenge: "What movie is this?",
			answer: "American Beauty",
			content: "americanbeauty.mp4",
			fullscreen: true,
			reveal: "americanbeauty.jpg",
		},
		// { category: "music", challenge: "What song is this?", answer: "Wake Me Up Before You Go-Go - Wham!" },
		// { category: "music", challenge: "What song is this?", answer: "Losing My Religion - R.E.M." },
		// {
		// 	category: "film",
		// 	challenge: "What movie is this?",
		// 	content: "dont-look-up.mp4",
		// 	fullscreen: true,
		// 	reveal: "dont-look-up.jpg",
		// 	answer: "Don't Look Up",
		// },
		// Justin Bieber - Ghost
		// What came first?  Chess, golf, soccer, bowling
		// {
		// 	challenge:
		// 		"What company is the primary electricity provider for BC interior communities including Kelowna and Castlegar?",
		// 	answer: "FortisBC (aka Fortis, formerly Terasen Gas)",
		// 	reveal: "FortisBC_logo.svg",
		// 	category: "local",
		// },
	],
]
